export class Observation { }

class pagination {
  public page: number;
  public page_size: number;
  public total_count: number;
  public total_pages: number;
  constructor(
    page: number,
    page_size: number,
    total_count: number,
    total_pages: number
  ) {
    this.page = page;
    this.page_size = page_size;
    this.total_count = total_count;
    this.total_pages = total_pages;
  }
}
export class RespSearchObservation {
  public success: boolean;
  public pagination: pagination;
  public data: any[];
  public message!: string;
  constructor(
    success: boolean,
    pagination: pagination,
    data: any[],
    message: string
  ) {
    this.success = success;
    this.pagination = pagination;
    this.data = data;
    this.message = message;
  }
}

export class RespCountriesObservation {
  public success: boolean;
  public data: string[];
  constructor(success: boolean, data: string[]) {
    this.success = success;
    this.data = data;
  }
}

export class RespRegionsObservation {
  public success: boolean;
  public data: string[];
  constructor(success: boolean, data: string[]) {
    this.success = success;
    this.data = data;
  }
}
export class RespGpsLocationsObservation {
  public success: boolean;
  public data: any[];
  constructor(success: boolean, data: any[]) {
    this.success = success;
    this.data = data;
  }
}
export class RespCatalogInfo {
  public success: boolean;
  public data: any;
  constructor(success: boolean, data: any) {
    this.success = success;
    this.data = data;
  }
}




export class RespWebService {
  success!: boolean;
  data: any;
}

export class RespStats {
  success!: boolean;
  data: any;
}

export class RespSync {
  success!: boolean;
  data: any;
  message!: string;
}


export class RespDelete {
  success!: boolean;
  data: any;
  message!: string;
}


